import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {IMT} from '@practicegenius/pg-util/src/StringUtils';
import {urlJoin} from '@practicegenius/pg-util/src/UrlUtils';
import {FILES_URL} from '../../../constants/env';
import lang from '../lang';

export const EmptyPage: React.FC<{
  name: string;
  logo: string;
}> = ({name, logo}) => {
  return (
    <Container>
      <Box sx={{width: '100%', display: 'flex', justifyContent: 'center'}}>
        <Box sx={{maxWidth: 176}}>
          <img
            src={urlJoin(FILES_URL, 'identity', logo)}
            alt={IMT(lang.empty.logoAlt, {name})}
          />
        </Box>
      </Box>
      <Box minHeight={580} pt={11} textAlign="center">
        <div>
          <Typography variant="h6" color="textSecondary">
            {lang.empty.title}
          </Typography>
        </div>
        <div>
          <Typography variant="subtitle1" color="textSecondary">
            {IMT(lang.empty.subtitle, {name})}
          </Typography>
        </div>
      </Box>
    </Container>
  );
};
